<script setup>
import config from '@/assets/config';
import Button from 'primevue/button';
import { useToast } from 'primevue/usetoast';
import { computed, ref, watch } from 'vue';
import { onBeforeRouteUpdate } from 'vue-router';

  const selectedNode = ref(null);
  const selectedNodeKey = ref('');
  const nodes = ref([]);
  const loading = ref(true);
  const error = ref(null);
  const toast = useToast();

  const notLoading = computed({
    get: () => !loading.value,
    set: (val) => {
      // when the child updates `visible`, invert and write back to `loading`
      loading.value = !val
    }
  })

  defineExpose({
    resetScopeAsync: resetScopeAsync,
  });

  const props = defineProps({
    responsible: {
      type: String,
      default: null
    },
    editing : {
      type: Boolean,
      default: false
    },
    filter: {
      type: String,
      default: null
    }
  });
  
  const emits = defineEmits(['scopeSelected', 'editionModeChanged', 'submitRequested']); 

  async function resetScopeAsync() {
    selectedNode.value = null;
    await loadScopeAsync(props.filter);
  }

  async function loadScopeAsync(filter) {
    loading.value = true; // Ativa o spinner antes de qualquer operação
    try {
        var responsible = localStorage.getItem('user') || null;
        console.log("Fetch the user scope asynchronously when the component is mounted for " + responsible);
        console.log("loading user and token from localStorage");
        const user = localStorage.getItem('user');
        const token = localStorage.getItem('token');
        console.log("building URL for fetching scope");
        let url = `${config.backendUrl}api/ControlsEvaluation/scope/${user}`;
        if (filter !== null) {
            if (filter === 'pending-control-points') {
                url += '?answered=false';
            } else if (filter === 'answered-control-points') {
                url += '?answered=true';
            }
        }
        console.log("Fetching scope from URL: " + url);
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
            }
        });
        console.log("Response status OK: " + response.status);
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        nodes.value = await response.json();
    } catch (err) {
        console.error('Error during scope loading:', err);
        error.value = err.message;
        toast.add({ severity: 'error', summary: 'Erro ao carregar o escopo', detail: err.message, life: 3000 });
    } finally {
        console.log("Scope loading completed");
        loading.value = false; // Desativa o spinner após a conclusão
    }
  }

  onBeforeRouteUpdate(async (to, from, next) => {
    await loadScopeAsync(to.params.filter || props.filter);
    next();
  });

  watch(() => props.filter, async (newValue) => {
    try {
      if (newValue !== undefined) {
        await loadScopeAsync(newValue);
      }
    } catch (error) {
      console.error('Error during watch execution:', error);
      toast.add({ severity: 'error', summary: 'Erro ao executar watch', detail: error.message, life: 3000 });
    }
  });

  function onSelectionChange(node) {
    console.log('Node selected:', node?.key);
    selectedNodeKey.value = node?.key;
    emits('scopeSelected', node?.key);
  }

  function onSelectionClear() {
    console.log('Node selection cleared');
    selectedNodeKey.value = '';
    emits('scopeSelected', null);
  }

  function beginEditMode() {
    emits('editionModeChanged', true);
  }

  function endEditMode() {
    emits('editionModeChanged', false);
  }

  function handleSendAnswers() {
    emits('submitRequested');
    endEditMode();
    toast.add({ severity: 'success', summary: 'Respostas Enviadas', detail: 'A submissão das respostas foi realizada com sucesso!', life: 3000 });
  }

  async function handleDiscardAnswers() {
    endEditMode();
    console.log('Node selected:', selectedNodeKey.value);
    emits('scopeSelected', selectedNodeKey.value);
  }

</script>

<template>
    <div>
      <Dialog v-model:visible="loading" modal :closable="false">
        <div class="spinner-container">
          <i class="pi pi-spin pi-spinner spinner"></i>
          <p>Carregando escopo...</p>
        </div>
      </Dialog>
    </div>

    <div class="card">

      <div class="font-semibold text-xl mb-4">Escopo</div>

      <TreeSelect 
        v-model:visible="notLoading"
        v-model="selectedNode" 
        :options="nodes" 
        :disabled="props.editing"
        placeholder="Selecione o escopo que deseja visualizar" 
        class="md:w-120 w-full" 
        @node-select="onSelectionChange"
        @node-unselect="onSelectionClear" />

        <div class="mt-2" v-if="props.editing">
          <Button label="Descartar Respostas" :disabled="!props.editing" @click="handleDiscardAnswers" class="mr-2" />
          <Button label="Enviar Respostas" :disabled="!props.editing" @click="handleSendAnswers" />
        </div>

      </div>
</template>
